export var BranchToBranchRequisitionAPIKeys = {
    create: 'branchToBranchRequisitionCreate',
    update: 'branchToBranchRequisitionUpdate',
    get: 'branchToBranchRequisitionGetById',
    paging: 'branchToBranchRequisitionPaging',
    statusProgress: 'branchToBranchRequisitionStatusProgress',
    attachmentList: 'branchToBranchRequisitionAttachmentList',
    downloadAttachmentList: 'branchToBranchRequisitionDownloadAttachmentList',
    branchToBranchRequisitionPartList: 'branchToBranchRequisitionPartList',
    uploadAttachment: 'branchToBranchRequisitionUploadAttachment',
    deleteAttachment: 'branchToBranchRequisitionDeleteAttachment',
    AttachmentSystemName: 'InventoryAttachment'
};
export var showColumnName = {
    DocumentCode: "Document Number",
    DocumentDate: "Requisition Date",
    CreatedOn: "Created date",
    SourceBranchName: "Source Branch",
    DestinationBranchName: "Destination Branch",
    TotalQuantity: "Total quantity",
    StatusName: "Status",
    TotalAmount: "Total amount"
};
export var BranchToBranchRequisitionFields = {
    'ProductId': 'Product',
    'RequestedQuantity': 'Requested Quantity'
};
